var _path, _path2, _g, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDepositWithdrawSuccess = function SvgDepositWithdrawSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 310,
    height: 222,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "deposit-withdraw-success_svg__b",
    width: 310,
    height: 242,
    x: 0,
    y: -16,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#deposit-withdraw-success_svg__a)",
    d: "M.5-16h309v241.5H.5z"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#deposit-withdraw-success_svg__b)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "deposit-withdraw-success_svg__d",
    width: 311,
    height: 306,
    x: -2,
    y: -79,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#deposit-withdraw-success_svg__c)",
    d: "M-1.606-78.171h309.659v304.445H-1.606z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 1.043,
    mask: "url(#deposit-withdraw-success_svg__d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 149.052,
    cy: 72.488,
    r: 150.137,
    fill: "#161616",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.052,
    cy: 72.489,
    r: 136.583,
    fill: "#161616",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.051,
    cy: 72.485,
    r: 123.029,
    fill: "#161616",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.051,
    cy: 72.487,
    r: 109.475,
    fill: "#161616",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.051,
    cy: 72.488,
    r: 95.921,
    fill: "#161616",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.051,
    cy: 72.49,
    r: 82.367,
    fill: "#161616",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.051,
    cy: 72.489,
    r: 67.77,
    fill: "#151515",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.052,
    cy: 72.485,
    r: 54.216,
    fill: "#191919",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.052,
    cy: 72.486,
    r: 40.662,
    fill: "url(#deposit-withdraw-success_svg__e)",
    stroke: "#252525"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 149.051,
    cy: 72.49,
    r: 28.151,
    fill: "url(#deposit-withdraw-success_svg__f)",
    stroke: "#424242",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#deposit-withdraw-success_svg__g)",
    stroke: "#424242",
    d: "M149.052 49.549c12.668 0 22.937 10.27 22.937 22.937 0 12.668-10.269 22.938-22.937 22.938-12.668 0-22.938-10.27-22.938-22.938s10.27-22.937 22.938-22.937Z",
    opacity: 0.8
  })))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#46DA93",
    stroke: "url(#deposit-withdraw-success_svg__h)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M149.32 62.732a9.567 9.567 0 0 1 9.567 9.568 9.567 9.567 0 0 1-9.567 9.567c-5.284 0-9.568-4.283-9.568-9.567s4.284-9.568 9.568-9.568Zm0 1.522a8.046 8.046 0 1 0 0 16.092 8.046 8.046 0 0 0 0-16.092Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#46DA93",
    stroke: "url(#deposit-withdraw-success_svg__i)",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.3,
    d: "M151.393 69.188a.761.761 0 0 1 .969-.317l.069.035a.762.762 0 0 1 .318.97l-.035.07-2.787 4.855c-.771 1.343-2.698 1.307-3.435-.013l-.067-.13-.527-1.124a.761.761 0 0 1 .297-.975l.068-.037a.762.762 0 0 1 .976.296l.037.07.526 1.122v0a.454.454 0 0 0 .767.089l.038-.056 2.786-4.856Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "deposit-withdraw-success_svg__a",
    x1: 155,
    x2: 155,
    y1: -0.699,
    y2: 181.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.826,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "deposit-withdraw-success_svg__e",
    x1: 149.052,
    x2: 149.052,
    y1: 31.303,
    y2: 113.67,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1F1F1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#272525",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "deposit-withdraw-success_svg__f",
    x1: 177.723,
    x2: 120.378,
    y1: 43.818,
    y2: 101.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2C2C2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1B1B1B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "deposit-withdraw-success_svg__g",
    x1: 125.593,
    x2: 172.511,
    y1: 49.027,
    y2: 95.945,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#252525"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#393939",
    stopOpacity: 0.67
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "deposit-withdraw-success_svg__h",
    x1: 149.32,
    x2: 149.32,
    y1: 62.582,
    y2: 82.018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EF8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC89D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "deposit-withdraw-success_svg__i",
    x1: 149.32,
    x2: 149.32,
    y1: 68.655,
    y2: 75.943,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8EF8C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6EC89D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "deposit-withdraw-success_svg__c",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(0 152.223 -154.829 0 153.223 74.052)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9",
    stopOpacity: 0
  })))));
};
export default SvgDepositWithdrawSuccess;